import React from 'react'

//starting with capital letter will ensure this is treated as a component
const InvRouteItemD = ({formObject, viewData, rowKey}) => {

    return (
        <div className="saras-cell">
            <ul className="uiSearchRouteItemList">
                {Object.values(viewData.childRows).map((row,index)=>(
                    <li>
                        <span className="sSeqNo">{row.rowValues.ref1.valF}</span>
                        <span className="sTktNo">{row.rowValues.ref2.valF}</span>
                        <span className="sItemCode">{row.rowValues.pnr.valF}</span>
                        <span className="sItemCode">{row.rowValues.itemCode.valF}</span>
                        <span className="sRoute">{row.rowValues.itemDetail.valF}</span>
                        <span className="sPassengerName">{row.rowValues.passengerName.valF}</span>
                        <span className="sTktClass">{row.rowValues.ticketClass.valF}</span>
                        <span className="sCost">{row.rowValues.costPrice.valF}</span>
                        <span className={`sCost ${row.rowValues.sellPrice.dataList.colCssClass}`}>{row.rowValues.sellPrice.valF}</span>
                    </li>
                ))
                }
            </ul>
        </div>
    );
}

export default InvRouteItemD
